import { action, payload } from 'ts-action'
import { IAccruedSickHour } from 'models/AccruedSickHour'
import { IError, IPayload } from 'models/Global'

export const AccruedSickHoursFetching = action(
  'AccruedSickHoursFetching',
  payload<boolean>(),
)

export const AddAccruedSickHour = action(
  'AddAccruedSickHour',
  payload<IPayload<IAccruedSickHour>>(),
)

export const UpdateAccruedSickHour = action(
  'UpdateAccruedSickHour',
  payload<IPayload<IAccruedSickHour>>(),
)

export const DeleteAccruedSickHour = action(
  'DeleteAccruedSickHour',
  payload<number>(),
)

export const GetAccruedSickHoursErrors = action(
  'GetAccruedSickHoursErrors',
  payload<IError>(),
)
